import { createFileRoute } from '@tanstack/react-router'

import { AiCostsPage } from '#/modules/ai-costs'

export const Route = createFileRoute('/_shell/ai-costs')({
  component: AiCostsPage,
})
